var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.492 1a1.5 1.5 0 011.5 1.5v9c0 .844-.656 1.5-1.5 1.5h-4.125a.38.38 0 01-.375-.375v-.25c0-.188.188-.375.375-.375h4.125c.281 0 .5-.219.5-.5v-9c0-.25-.219-.5-.5-.5h-4.125a.38.38 0 01-.375-.375v-.25c0-.188.188-.375.375-.375h4.125zm-8.719.625l.25.219a.423.423 0 010 .531L2.898 6.469h8.72a.38.38 0 01.374.375v.312a.361.361 0 01-.375.375H2.898l4.094 4.125a.36.36 0 010 .531l-.219.22c-.125.155-.375.155-.53 0L1.116 7.28a.36.36 0 010-.531l5.125-5.125c.156-.156.406-.156.531 0z",
    fill: "#AAC4F9",
    stroke: "#AAC4F9",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.7fdfcba44717189b3d5817045c4ac224.svg";
export { ForwardRef as ReactComponent };